import { useEffect } from 'react';
import type { INotificationItem } from '@interfaces/INotificationItem';
import { NotificationItemBody } from '../NotificationRow/NotificationRow';
import styles from './ArrivalPeek.module.css';

export interface IArrivalPeekProps {
  items: INotificationItem[]; // What just arrived, drawn as the menu would draw it.
  onOpenItem: (item: INotificationItem) => void;
  onHoverChange: (hovering: boolean) => void; // Told when the pointer comes to rest on the peek, and when it leaves — or the peek goes.
}

/**
 * A glimpse under the bell of what just arrived: the same rows the menu
 * shows, for a moment, without opening it. Each row opens what it is about,
 * as in the menu. Read out as a status, so a screen reader hears it once.
 */
export function ArrivalPeek({ items, onOpenItem, onHoverChange }: IArrivalPeekProps) {
  // Gone from under the pointer, it gets no leave from the browser: say it here.
  useEffect(
    () => {                        // 1. runs when the peek appears
      return () => {               // 2. runs when the peek disappears
        onHoverChange(false);
      };
    },
    [onHoverChange],
  );
  
  return (
    <div
      className={styles.peek}
      role="status"
      onMouseEnter={() => onHoverChange(true)}
      onMouseLeave={() => onHoverChange(false)}
    >
      {items.map((item) => (
        <button key={item.id} type="button" className={styles.row} onClick={() => onOpenItem(item)}>
          <NotificationItemBody item={item} />
        </button>
      ))}
    </div>
  );
}
